import { Advert } from "@model/entities/advert"
import { Blog } from "@model/entities/blog"
import { Job } from "@model/entities/job"
import { Wiki } from "@model/entities/wiki"
import { SerializationService, Serialize } from "aautil"

export class News {

  @Serialize({
    from: {
      map: (raw: any, svc: SerializationService) => svc.deserializeMany(Blog, raw),
      deps: [SerializationService],
    },
  })
  blog: Blog[] = []

  @Serialize({
    from: {
      map: (raw: any, svc: SerializationService) => svc.deserializeMany(Advert, raw),
      deps: [SerializationService],
    },
  })
  advert: Advert[] = []

  @Serialize({
    from: {
      map: (raw: any, svc: SerializationService) => svc.deserializeMany(Job, raw),
      deps: [SerializationService],
    },
  })
  job: Job[] = []

  @Serialize({
    from: {
      map: (raw: any, svc: SerializationService) => svc.deserializeMany(Blog, raw),
      deps: [SerializationService],
    },
  })
  video: Blog[] = []

  @Serialize({
    from: {
      map: (raw: any, svc: SerializationService) => svc.deserializeMany(Wiki, raw),
      deps: [SerializationService],
    },
  })
  wiki: Wiki[] = []

}